import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  getSbatGroupsSuperBatchIds,
  resetSbatGroupBulkUpdate,
  selectedBulkUpdateSbatGroupsSelector,
  useBulkAddSuperBatchesMutation,
  VIEW_SCHEDULE_PAGE_TRACKINGS,
} from 'features/classCreation';
import analytics from 'utils/analytics';
import GlobalLoader from 'components/GlobalLoader';

function BulkAddSuperBatchesButton({
  selectedSuperBatches,
  setSelectedSuperBatches,
}) {
  const dispatch = useDispatch();
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);
  const [bulkAddSuperBatches, { isSuccess, error, isLoading: isAdding }] =
    useBulkAddSuperBatchesMutation();

  const handleBulkAddSuperBatches = useCallback(() => {
    const superBatchIds = selectedSuperBatches.map(
      (superBatch) => superBatch.id
    );

    const sbatGroupIds = Object.keys(selectedSbatGroups);
    const previousSuperBatchIds =
      getSbatGroupsSuperBatchIds(selectedSbatGroups);

    analytics.click({
      click_type: VIEW_SCHEDULE_PAGE_TRACKINGS.bulkAddSuperBatches,
      custom: {
        class_ids: sbatGroupIds,
        num_of_classes: sbatGroupIds.length,
        previous_super_batch_ids: previousSuperBatchIds,
        added_super_batch_ids: superBatchIds,
      },
    });
    bulkAddSuperBatches({
      sbatGroupIds: sbatGroupIds,
      superBatchIds: superBatchIds,
    });
  }, [bulkAddSuperBatches, selectedSbatGroups, selectedSuperBatches]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetSbatGroupBulkUpdate());
      setSelectedSuperBatches([]);
      cogoToast.success('Selected batches are added successfully!');
    }
  }, [dispatch, isSuccess, setSelectedSuperBatches]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isAdding} />
      <Tappable
        className="btn btn-primary m-t-s"
        onClick={handleBulkAddSuperBatches}
        disabled={isAdding}
      >
        Apply Changes
      </Tappable>
    </>
  );
}

export default BulkAddSuperBatchesButton;
